import React from 'react'
import { useSelector } from 'react-redux'
import { startCase } from 'lodash'
import { IconSquareCheck, IconSquareFilled } from '@tabler/icons-react'

import classNames from 'classnames'
import pluralize from 'pluralize'

import { matchUpdateProgress } from '@/views/Playbooks/playbook.helpers'
import { ExternalLink } from '@/components/ExternalLink'
import { Pill } from '@/components/pills/Pill'
import { PlaybookProgressIcon } from './PlaybookProgressIcon'

export const PlaybookPreviewSelectable = ({
  match,
  section,
  handleSelectSingle,
  children,
  showOrg,
}) => {
  const { massPlaybookUpdate } = useSelector((state) => state.playbooks)
  const { selection } = massPlaybookUpdate || {}

  const isSelected = selection.includes(match.compoundId)

  return (
    <div className="flex-center">
      <div className={classNames('playbook-card-preview', { [`${section}-preview`]: !!section })}>
        <div
          className="playbook-card-preview__header-selectable"
          onClick={() => handleSelectSingle(match.compoundId)}
        >
          <div className="flex flex-align-center full-width gap">
            {match.progress === matchUpdateProgress.INITIAL ? (
              isSelected ? (
                <IconSquareCheck />
              ) : (
                <IconSquareFilled />
              )
            ) : (
              <PlaybookProgressIcon darkBg progress={match.progress} />
            )}
            <div className="flex-column flex-item flex-align-start small-gap">
              {showOrg && <Pill xs>{match.organizationName}</Pill>}
              <div className="light-muted-text">{match.config_name}</div>
              <div>{match.content || `${startCase(pluralize.singular(section))} title`}</div>
            </div>
            <ExternalLink
              light
              onClick={(event) => {
                event.stopPropagation()
              }}
              target="_blank"
              url={`/playbooks/${match.config_id}/dynamic-prompts`}
            />
          </div>
        </div>
        <div className="playbook-card-preview__content">{children}</div>
      </div>
    </div>
  )
}
